/**
 * Brand color tokens shared between the MUI theme and the engine layer.
 * Keep this file free of framework dependencies so engine code can import it.
 */
export const PRIMARY_COLOR = '#00a5b9';
export const SECONDARY_COLOR = '#f49800';
